import { ReactNode, createContext, useContext } from 'react';
import { BrandAndCategoryIdType, BrandType, CoKitchenPolygons } from 'utils/types';
import { CoKitchenType } from 'utils/types';
import { ENUM_CATEGORY, ENUM_SEARCH_TYPE } from 'utils/enum';
import { RolePermissionType } from 'utils/permissions-type';

export type DashboardContextType = {
  activeCokitchen: CoKitchenType;
  setActiveCokitchen: (kitchen: CoKitchenType) => void;
  activeBrand: BrandType;
  setActiveBrand: (brand: BrandType) => void;
  cokitchens: CoKitchenType[];
  setCokitchens: (kitchens: CoKitchenType[]) => void;
  refetchCokitchens: () => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
  rightSection: ReactNode | null;
  setRightSection: (value: ReactNode | null) => void;
  isRightSectionWide: boolean;
  setIsRightSectionWide: (value: boolean) => void;
  hasNotifications?: boolean;
  searchFilter: ENUM_SEARCH_TYPE;
  setSearchFilter: (item: ENUM_SEARCH_TYPE) => void;
  showMobileSidebar: boolean;
  setShowMobileSidebar: (value: boolean) => void;
  mealInfo: BrandAndCategoryIdType[];
  setMealInfo: (value: BrandAndCategoryIdType[]) => void;
  activePolygon: CoKitchenPolygons | null;
  setActivePolygon: (value: CoKitchenPolygons | null) => void;
  cokitchenPolygons: CoKitchenPolygons[];
  setCokitchenPolygons: (value: CoKitchenPolygons[]) => void;
  category: ENUM_CATEGORY;
  setCategory: (value: ENUM_CATEGORY) => void;
  cokitchenLoading: boolean;
  setCokitchenLoading: (arg0: boolean) => void;
  trash: boolean;
  customSearch: string;
  setCustomSearch: (arg0: string) => void;
  isCustomSearch: boolean;
  setIsCustomSearch: (arg0: boolean) => void;
  isFcb: boolean;
  setIsFcb: (val: boolean) => void;
  routePrefix: string;
  loggedInRole: string;
  permissions: RolePermissionType;
};

export const DashboardContext = createContext({} as DashboardContextType);

const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};

export default useDashboardContext;
